import { Icon, Stepper } from '@scuf/common';
import { StepWizardChildProps } from 'react-step-wizard';
import React from 'react';
import { IIconRoot } from '@scuf/common/dist/types';

export interface INavbarIconProps {
  completed: string | React.ReactElement<HTMLImageElement>;
  notVisited: string | React.ReactElement<HTMLImageElement>;
  active: string | React.ReactElement<HTMLImageElement>;
}
export interface INavbar {
  title: string;
  description: string;
  icon?: string | React.ReactElement<HTMLImageElement>;
  iconRoot?: IIconRoot;
}

interface INavbarProps extends StepWizardChildProps {
  navSteps: INavbar[];
  navIcons?: INavbarIconProps;
}

const Navbar = (props: INavbarProps) => {
  return (
    <Stepper>
      {props.navSteps.map((item, index) => {
        let currentIcon:
          | string
          | React.ReactElement<
              HTMLImageElement
            > = item.icon as React.ReactElement<HTMLImageElement>;
        if (
          !item.icon &&
          props.navIcons &&
          props.navIcons.hasOwnProperty('completed')
        ) {
          if (props.currentStep > index + 1) {
            currentIcon = (props.navIcons as INavbarIconProps).completed;
          } else if (!(props.currentStep > index)) {
            currentIcon = (props.navIcons as INavbarIconProps).notVisited;
          } else {
            currentIcon = (props.navIcons as INavbarIconProps).active;
          }
        }
        return (
          <Stepper.Item
            key={index}
            title={item.title}
            description={item.description}
            iconRoot={item.iconRoot}
            icon={currentIcon}
            className={props.currentStep === index + 1 ? 'active-step' : ''}
            completed={props.currentStep > index + 1}
            disabled={!(props.currentStep > index)}
            onClick={() => {
              props.goToStep(index + 1);
            }}
          />
        );
      })}
    </Stepper>
  );
};
export default Navbar;
